<template>
    <v-list shaped>
        <v-list color="primary">
            <v-list-item
                v-for="(item, i) in items"
                :key="i"
                :to="item.path"
                :active="item.path === $route.path"
                :class="{
                    'mt-10': item.spaceAbove,
                }"
                @mouseover="hover = item.text"
                @mouseleave="hover = null"
            >
                <template v-slot:prepend>
                    <v-icon>{{ item.icon }}</v-icon>
                </template>

                <v-list-item-title class="text-left">{{ item.text }}</v-list-item-title>

                <template v-slot:append>
                    <v-tooltip
                        location="right"
                        v-if="item.createLink && isVisible(item.createLink) && hover === item.text"
                    >
                        <template v-slot:activator="{ props }">
                            <v-btn
                                class="mx-2"
                                color="primary"
                                icon
                                variant="text"
                                size="x-small"
                                @click.prevent="openCreateView(item)"
                                v-bind="props"
                            >
                                <v-icon>$plus</v-icon>
                            </v-btn>
                        </template>
                        <span>New {{ item.text.slice(0, -1) }}</span>
                    </v-tooltip>
                </template>
            </v-list-item>
        </v-list>
    </v-list>
</template>
<script>
import { defineComponent } from "vue";

import { mapGetters } from "vuex";
import { allMenuItems } from "../../lib/routes";
import { isAuthorizedForPermissions } from "../../lib/auth";

export default defineComponent({
    name: "NavigationMenu",
    mounted() {},

    methods: {
        openCreateView: function (item) {
            const { path, query } = item.createLink;
            this.$router.push({
                path,
                query,
            });
        },
        isVisible(item) {
            return (
                item.permissions === undefined ||
                isAuthorizedForPermissions(item.permissions, this.getAuthUser)
            );
        },
    },

    computed: {
        ...mapGetters(["isAuthenticated", "getAuthUser"]),
        items: function () {
            return allMenuItems.filter((item) => this.isVisible(item));
        },
    },

    data: function () {
        return {
            item: 1,
            hover: null,
            openedItems: [], // Add this line
        };
    },
});
</script>
